import { render, staticRenderFns } from "./InquiryLanding.vue?vue&type=template&id=1856259f&scoped=true&"
import script from "./InquiryLanding.vue?vue&type=script&lang=js&"
export * from "./InquiryLanding.vue?vue&type=script&lang=js&"
import style0 from "./InquiryLanding.vue?vue&type=style&index=0&id=1856259f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1856259f",
  null
  
)

export default component.exports